import { render, staticRenderFns } from "./ServicesLayout.vue?vue&type=template&id=74f1d592&scoped=true&lang=pug"
import script from "./ServicesLayout.vue?vue&type=script&lang=ts"
export * from "./ServicesLayout.vue?vue&type=script&lang=ts"
import style0 from "./ServicesLayout.vue?vue&type=style&index=0&id=74f1d592&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f1d592",
  null
  
)

export default component.exports